import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useConsumablesMasterHook from './consumables-master.hook';
import * as styled from './consumables-master.styles';
import themes from './themes';

import EditableTable from '../../components/edit-table';
import Modal from '@plasma/ui.layout.modal';
import Select from '@plasma/ui.input.select';
import Button from '@plasma/ui.general.button';
import SimpleList from '@plasma/ui.display.simple-list';
import { CancelButton } from '@plasma/ui.general.button/dist/buttons-variations';

const { Option } = Select;

export interface ConsumablesMasterProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = ConsumablesMasterProps & ThemeOverride;

function ConsumablesMaster(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
          dataForColumns,
          columnNames,
          hiddenColumns,
          modalVisible,
          dataToShowInModal,
          finaldataForColumns,
          productName,
          productDescription,
          distinctProdName,
          descriptionByProdName,
          isSelectedLoading,
          selectedIndex,
          modalTitle,
          handleSaveAndDeleteFromTable,
          handleSelectedRow,
          HandleSaveFromModal,
          HandleModalCancel,
          handleProductNameChange,
          handleProductDescriptionChange,
          handleAddProduct,
          removeItemFromAddedList,
          handleClearAll,
          ResetselectedIndex
        } = useConsumablesMasterHook(props);

  // const handleSaveRow = (newData: { [key: string]: any }) => {
  //   //console.log("SAVE: ",newData);
  //   handleSaveFromTable(newData);
  // }



  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ConsumablesMaster className={`consumables-master ${className ?? ''}`.trim()} style={style}>

        <EditableTable
          tableData={finaldataForColumns}
          tableColumns={columnNames}
          Table_Header='CONSUMABLE EDITOR'
          hiddenColumns={hiddenColumns}
          stillHiddenColumns={['quantityredressed','lineseq', 'displayseq']}
          handleSave={handleSaveAndDeleteFromTable}
          showActions_ext = {true}
          allowSelection = {true}
          rowIndexSelected={selectedIndex}
          handleSelection={handleSelectedRow}
          selectInputReturnType={'value'}
          saveReturnType={'row'}
          onlyAddableFields={['consumablecode', 'consumablename', 'consumablecodeext']}
          expandableColumns={['productprofiles']}
          clearTheSelection={ResetselectedIndex}
          showLoadingOnSelection= {isSelectedLoading}
        />


        <Modal
          title={`Attach Profiles & Drawing for Consumable: ${modalTitle}`}
          width={'fit-content'}
          okText="Save"
          visible={modalVisible}
          onCancel={() => HandleModalCancel()}
          onOk={() => HandleSaveFromModal()}
          destroyOnClose={true}
        >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', background: 'linear-gradient(to top left, #f0f0f5, #33adff44)', padding: '15px 20px 20px 20px', borderRadius: '5px'}}>

          <div>

            {/* <div style={{margin: '10px 0px 0px 20px', width: '8vw', textWrap: 'balance',textDecoration: 'underline', fontSize: '15px'}}>
              Product Name :
            </div> */}
            <Select
              style={{ width: '220px', margin: '20px 20px 10px 20px' }}
              placeholder='Product'
              onChange={handleProductNameChange}
              // disabled = {addedItems.length>0 ? true : false}
              value={productName}
            >
              { distinctProdName?.map((item, index)=> (
              <Option key={index} value={item}>
                {item}
              </Option>
              ))}

            </Select> <br/>

            {/* <div style={{marginLeft: '20px', width: '8vw', textWrap: 'balance',textDecoration: 'underline', fontSize: '15px'}}>
              Product Description :
            </div> */}
            <Select
              style={{ width: '220px', margin:'10px 20px 15px 20px'}}
              placeholder='Description'
              onChange={handleProductDescriptionChange}
              value={productDescription}
            >
              { descriptionByProdName?.map((item, index)=> (
              <Option key={index} value={item}>
                {item}
              </Option>
              ))}
            </Select>

          <div style={{display: 'flex', marginLeft: '20px', marginTop:'15px'}}>
            <div style={{}}>
              <Button style={{  }} onClick={handleClearAll} title="Clear All" type='secondary'  />
            </div>

            <div style={{marginLeft: '12px'}}>
              <Button style={{ marginRight: '5px' }} onClick={handleAddProduct} title="Add Profile " type="secondary" suffixIcon= {{name: 'add_circle_outline'}} />
            </div>
          </div>
            <br/>
            {/* <div style={{marginLeft: '20px',width: '11vw',textWrap: 'balance', fontSize: '15px', color: '#ff0000'}}>
              {message}
            </div> */}
          </div>

          <div style={{marginBottom: '15px'}} >
            <SimpleList
              dataSource={dataToShowInModal.productprofiles}
              style={{overflowY: 'auto', maxHeight:'40vh', borderColor: '#8b8b8c', borderRadius: '5px'}}
              renderItem={(item) => (
                <div style={
                          {marginLeft: '15px',
                          marginTop:'5px',
                          display: 'flex',
                          padding: '5px',
                          alignItems: 'center'
                      }}>

                  <div style={{ display: 'flex', alignItems: 'flex-start'}}>

                    <div style={{marginRight: '5px', padding:'2px', backgroundColor: '#FFFFBB', borderRadius: '5px', border: '1px solid #FF9900'}}>
                      {item.producttype}
                    </div>
                    <div style={{marginRight: '5px'}}>
                      :
                    </div>
                    <div style={{ width: 'max-content', padding:'2px', backgroundColor: '#AAFFAA', borderRadius: '5px', border: '1px solid #00FF00'}}>
                      {item.productdescription}
                    </div>

                  </div>

                  <div style={{  width: '100%'}}>
                    <Button
                      key="btn1"
                      prefixIcon={{name: 'delete_outline'}}
                      type="tertiary"
                      size="small"
                      style={{ marginLeft: 'auto' }}
                      onClick={() => removeItemFromAddedList({producttype: item.producttype, productdescription: item.productdescription})}
                      />
                  </div>
                </div>

                )}
              itemLayout="horizontal"
              header={
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <div style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                        Profile List: {dataToShowInModal.productprofiles?.length} items
                      </div>
                      {/* <div style={{marginLeft:'2px'}}>
                      <Button style={{  }} onClick={handleClearAll} title="Clear" type="secondary" suffixIcon= {{name: 'backspace'}} />
                      </div> */}
                    </div>
                    }
              bordered
            />
          </div>
        </div>

        </Modal>

      </styled.ConsumablesMaster>
    </ThemeProvider>
  );
}

export default memo(ConsumablesMaster) as unknown as typeof ConsumablesMaster;
